"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logging = exports.Instrument = void 0;
var _instrumentBase = require("../../utils/instrument-base");
var _constants = require("../constants");
var _utils = require("../shared/utils");
var _wrapLogger = require("../../../common/wrap/wrap-logger");
var _runtime = require("../../../common/constants/runtime");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

class Instrument extends _instrumentBase.InstrumentBase {
  static featureName = _constants.FEATURE_NAME;
  constructor(agentRef, auto = true) {
    super(agentRef, _constants.FEATURE_NAME, auto);
    const instanceEE = this.ee;
    (0, _wrapLogger.wrapLogger)(instanceEE, _runtime.globalScope.console, 'log', {
      level: 'info'
    });
    (0, _wrapLogger.wrapLogger)(instanceEE, _runtime.globalScope.console, 'error', {
      level: 'error'
    });
    (0, _wrapLogger.wrapLogger)(instanceEE, _runtime.globalScope.console, 'warn', {
      level: 'warn'
    });
    (0, _wrapLogger.wrapLogger)(instanceEE, _runtime.globalScope.console, 'info', {
      level: 'info'
    });
    (0, _wrapLogger.wrapLogger)(instanceEE, _runtime.globalScope.console, 'debug', {
      level: 'debug'
    });
    (0, _wrapLogger.wrapLogger)(instanceEE, _runtime.globalScope.console, 'trace', {
      level: 'trace'
    });
    /** emitted by wrap-logger function */
    this.ee.on('wrap-logger-end', function handleLog([message]) {
      const {
        level,
        customAttributes
      } = this;
      (0, _utils.bufferLog)(instanceEE, message, customAttributes, level);
    });
    this.importAggregator(agentRef);
  }
}
exports.Instrument = Instrument;
const Logging = exports.Logging = Instrument;